// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("damages_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("loss_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("needbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;

}


.iconimg {
    width: 27px;
    height: 27px;
    margin-left: 5px;
}

.badgholder {
    width: 80px;
    height: "100%";
    float: left;
}

.damagesbadge {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /*height: 120px;*/
    height: 80px;
    width: 80px;
    float: right;
    background-repeat: no-repeat;
}

.lossbadge {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    /*height: 120px;*/
    height: 80px;
    width: 80px;
    float: right;
    background-repeat: no-repeat;
}

.needbadge {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 87px;
    width: 87px;
    float: right;
}

.catbox {
    height: 87px;
    width: 107px;
    float: left;
    padding: 4px 0px 0px 0px;

}

.dmgh1 {
    font-size: 18px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: #000000;
    float: left;
    width: 100%;
    text-align: center;
    padding: 2px 0px 0px 0px;
    text-transform: uppercase;
}

.dmgh2 {
    font-size: 13px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: #ffffff;
    float: left;
    width: 100%;
    text-align: center;
    padding: 10px 0px 0px 0px;
    text-transform: uppercase;
}

.lossh1 {
    font-size: 18px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: #000000;
    float: left;
    width: 100%;
    text-align: center;
    padding: 38px 0px 0px 0px;
    text-transform: uppercase;
}

.needh1 {
    font-size: 18px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: #ffffff;
    float: right;
    width: 100%;
    text-align: center;
    padding: 4px 0px 0px 0px;
    text-transform: uppercase;
    height: 19px;
}

.needh2 {
    font-size: 14px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: black;
    float: left;
    width: 100%;
    text-align: center;
    padding: 10px 0px 0px 0px;
    text-transform: uppercase;
}

.needh3 {
    font-size: 11px;
    font-family: 'Oswald', sans-serif;
    font-weight: 300;
    color: #ffffff;
    float: left;
    width: 100%;
    text-align: center;
    padding: 2px 0px 0px 0px;
}


.catrotate {

    transform: rotate(-90deg);
    font-size: 18px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
    color: #000000;
    float: left;
    text-align: center;

    text-transform: uppercase;

    /* Legacy vendor prefixes that you probably don't need... */

    /* Safari */
    -webkit-transform: rotate(-90deg);

    /* Firefox */
    -moz-transform: rotate(-90deg);

    /* IE */
    -ms-transform: rotate(-90deg);

    /* Opera */
    -o-transform: rotate(-90deg);

    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);

}

.header-text {
    color: #ffffff;
    font-family: "Barlow Semi Condensed", Helvetica;
    font-size: 1rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 20px;
    position: relative;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/components/dark_version/static/badge.css"],"names":[],"mappings":"AAAA;IACI,SAAS;;AAEb;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yDAAuC;IACvC,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,yDAAoC;IACpC,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,yDAAmC;IACnC,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,wBAAwB;;AAE5B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;;;AAGA;;IAEI,yBAAyB;IACzB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;;IAElB,yBAAyB;;IAEzB,2DAA2D;;IAE3D,WAAW;IACX,iCAAiC;;IAEjC,YAAY;IACZ,8BAA8B;;IAE9B,OAAO;IACP,6BAA6B;;IAE7B,UAAU;IACV,4BAA4B;;IAE5B,sBAAsB;IACtB,gEAAgE;;AAEpE;;AAEA;IACI,cAAc;IACd,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["body {\n    margin: 0;\n\n}\n\n\n.iconimg {\n    width: 27px;\n    height: 27px;\n    margin-left: 5px;\n}\n\n.badgholder {\n    width: 80px;\n    height: \"100%\";\n    float: left;\n}\n\n.damagesbadge {\n    background-image: url(\"damages_bg.png\");\n    /*height: 120px;*/\n    height: 80px;\n    width: 80px;\n    float: right;\n    background-repeat: no-repeat;\n}\n\n.lossbadge {\n    background-image: url(\"loss_bg.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    /*height: 120px;*/\n    height: 80px;\n    width: 80px;\n    float: right;\n    background-repeat: no-repeat;\n}\n\n.needbadge {\n    background-image: url(\"needbg.png\");\n    height: 87px;\n    width: 87px;\n    float: right;\n}\n\n.catbox {\n    height: 87px;\n    width: 107px;\n    float: left;\n    padding: 4px 0px 0px 0px;\n\n}\n\n.dmgh1 {\n    font-size: 18px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: #000000;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 2px 0px 0px 0px;\n    text-transform: uppercase;\n}\n\n.dmgh2 {\n    font-size: 13px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: #ffffff;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 10px 0px 0px 0px;\n    text-transform: uppercase;\n}\n\n.lossh1 {\n    font-size: 18px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: #000000;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 38px 0px 0px 0px;\n    text-transform: uppercase;\n}\n\n.needh1 {\n    font-size: 18px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: #ffffff;\n    float: right;\n    width: 100%;\n    text-align: center;\n    padding: 4px 0px 0px 0px;\n    text-transform: uppercase;\n    height: 19px;\n}\n\n.needh2 {\n    font-size: 14px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: black;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 10px 0px 0px 0px;\n    text-transform: uppercase;\n}\n\n.needh3 {\n    font-size: 11px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 300;\n    color: #ffffff;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 2px 0px 0px 0px;\n}\n\n\n.catrotate {\n\n    transform: rotate(-90deg);\n    font-size: 18px;\n    font-family: 'Oswald', sans-serif;\n    font-weight: 400;\n    color: #000000;\n    float: left;\n    text-align: center;\n\n    text-transform: uppercase;\n\n    /* Legacy vendor prefixes that you probably don't need... */\n\n    /* Safari */\n    -webkit-transform: rotate(-90deg);\n\n    /* Firefox */\n    -moz-transform: rotate(-90deg);\n\n    /* IE */\n    -ms-transform: rotate(-90deg);\n\n    /* Opera */\n    -o-transform: rotate(-90deg);\n\n    /* Internet Explorer */\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n\n}\n\n.header-text {\n    color: #ffffff;\n    font-family: \"Barlow Semi Condensed\", Helvetica;\n    font-size: 1rem;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 20px;\n    position: relative;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
